var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg281(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C42 40.8366 34.8366 48 26 48C17.1634 48 10 40.8366 10 32C10 23.1634 17.1634 16 26 16C34.8366 16 42 23.1634 42 32Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 42.6274 48.6274 48 42 48C35.3726 48 30 42.6274 30 36C30 29.3726 35.3726 24 42 24C48.6274 24 54 29.3726 54 36Z",
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H42V48H26V40Z",
    fill: "#EDEDED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.6538,
    y: 50,
    width: 3,
    height: 6,
    rx: 1.5,
    transform: "rotate(16 17.6538 50)",
    fill: "#01E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6538,
    y: 50,
    width: 3,
    height: 6,
    rx: 1.5,
    transform: "rotate(16 24.6538 50)",
    fill: "#01E5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51.5V50H42V51.5H30Z",
    fill: "#E3E3E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 51.5C42.2955 51.5 42.5881 51.4418 42.861 51.3287C43.134 51.2157 43.3821 51.0499 43.591 50.841C43.7999 50.6321 43.9657 50.384 44.0787 50.111C44.1918 49.8381 44.25 49.5455 44.25 49.25C44.25 48.9545 44.1918 48.6619 44.0787 48.389C43.9657 48.116 43.7999 47.8679 43.591 47.659C43.3821 47.4501 43.134 47.2843 42.861 47.1713C42.5881 47.0582 42.2955 47 42 47L42 48.4982C42.0987 48.4982 42.1965 48.5177 42.2877 48.5554C42.3789 48.5932 42.4618 48.6486 42.5316 48.7184C42.6014 48.7882 42.6568 48.8711 42.6946 48.9623C42.7323 49.0535 42.7518 49.1513 42.7518 49.25C42.7518 49.3487 42.7323 49.4465 42.6946 49.5377C42.6568 49.6289 42.6014 49.7118 42.5316 49.7816C42.4618 49.8514 42.3789 49.9068 42.2877 49.9446C42.1965 49.9823 42.0987 50.0018 42 50.0018V51.5Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52.25V53.75H45V52.25H30Z",
    fill: "#E3E3E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 52.25C45.2955 52.25 45.5881 52.3082 45.861 52.4213C46.134 52.5343 46.3821 52.7001 46.591 52.909C46.7999 53.1179 46.9657 53.366 47.0787 53.639C47.1918 53.9119 47.25 54.2045 47.25 54.5C47.25 54.7955 47.1918 55.0881 47.0787 55.361C46.9657 55.634 46.7999 55.8821 46.591 56.091C46.3821 56.2999 46.134 56.4657 45.861 56.5787C45.5881 56.6918 45.2955 56.75 45 56.75L45 55.2518C45.0987 55.2518 45.1965 55.2323 45.2877 55.1946C45.3789 55.1568 45.4618 55.1014 45.5316 55.0316C45.6014 54.9618 45.6568 54.8789 45.6946 54.7877C45.7323 54.6965 45.7518 54.5987 45.7518 54.5C45.7518 54.4013 45.7323 54.3035 45.6946 54.2123C45.6568 54.1211 45.6014 54.0382 45.5316 53.9684C45.4618 53.8986 45.3789 53.8432 45.2877 53.8054C45.1965 53.7677 45.0987 53.7482 45 53.7482V52.25Z",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54.5V56H40.5V54.5H30Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 54.5C40.7955 54.5 41.0881 54.5582 41.361 54.6713C41.634 54.7843 41.8821 54.9501 42.091 55.159C42.2999 55.3679 42.4657 55.616 42.5787 55.889C42.6918 56.1619 42.75 56.4545 42.75 56.75C42.75 57.0455 42.6918 57.3381 42.5787 57.611C42.4657 57.884 42.2999 58.1321 42.091 58.341C41.8821 58.5499 41.634 58.7157 41.361 58.8287C41.0881 58.9418 40.7955 59 40.5 59L40.5 57.5018C40.5987 57.5018 40.6965 57.4823 40.7877 57.4446C40.8789 57.4068 40.9618 57.3514 41.0316 57.2816C41.1014 57.2118 41.1568 57.1289 41.1946 57.0377C41.2323 56.9465 41.2518 56.8487 41.2518 56.75C41.2518 56.6513 41.2323 56.5535 41.1946 56.4623C41.1568 56.3711 41.1014 56.2882 41.0316 56.2184C40.9618 56.1486 40.8789 56.0932 40.7877 56.0554C40.6965 56.0177 40.5987 55.9982 40.5 55.9982V54.5Z",
    fill: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg281);
export default __webpack_public_path__ + "static/media/281.aa9664ab0011e19bb7ea7a10511ef8f1.svg";
export { ForwardRef as ReactComponent };